import Platform from "../../../../libs/utility/Platform";

export default {
    mainContainer: {
        display: "flex",
        columnGap: "40px",
    },

    headerContainer: {
        width: "100%",
        padding: "10px 20px 0px 20px",
    },

    titleAndSearch: {
        paddingBottom: "30px",
        display: "flex",
        justifyContent: "space-between"
    },

    icons: {
        display: "flex",
        columnGap: '15px',
        alignItems: "center"
    },

    cardContainer: {
        width: "40%",
    },

    selectAllCBox: {
        padding: "16px"
    },

    payerInformationContainer: {
        background: "#FFFFFF",
        boxShadow: "0px 10px 10px rgba(38, 38, 38, 0.05)",
        borderRadius: "12px",
        width: "60%",
        padding: "40px"
    },

    assignToUserTablePopup: {
        width: "70%",
        maxWidth: "1200px",
        // padding: "40px",
    },

    noPayersFoundContainer: {
        textAlign: "center",
        marginTop: "100px"
    },

    searchContainer: {
        display: "flex",
    },

    dropdownContainer: {
        width: "135px",
        marginRight: "20px"
    },

    dropdownInput: {
        caretColor: "transparent",
    },
    selectAllAndSortActionContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: Platform.isMobileView() ? "100%" : '40%',
    },
    sortIcondiv:{
        padding:"15px",
        marginLeft: "auto",
        marginRight:"20px"
    }
}